import { render, staticRenderFns } from "./BuilderIntegrations.vue?vue&type=template&id=3babecbe"
import script from "./BuilderIntegrations.vue?vue&type=script&lang=js"
export * from "./BuilderIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports